module.exports = __webpack_public_path__ + "img/u6.40f1c74d.jpg";